var map = {
	"./back.svg": "972b",
	"./cart.svg": "9318",
	"./cart_white.svg": "3cf1",
	"./code.svg": "d7a0",
	"./collect.svg": "052b",
	"./collect_cur.svg": "ba37",
	"./collect_del.svg": "0b09",
	"./coupon.svg": "2ec3",
	"./coupon_cur.svg": "dcf2",
	"./customer_cur.svg": "929b",
	"./delete.svg": "a3dd",
	"./home_cur.svg": "cde3",
	"./icon-ckt.svg": "ab11",
	"./icon_collect.svg": "9bee",
	"./integral.svg": "97e1",
	"./integral_icon.svg": "45e7",
	"./like-block.svg": "83a8",
	"./location.svg": "87a1",
	"./login_mine.svg": "fb13",
	"./notice.svg": "ee69",
	"./order_icon.svg": "1ebc",
	"./order_icon1.svg": "4134",
	"./order_icon1_cur.svg": "09b8",
	"./order_icon2.svg": "76d1",
	"./order_icon2_cur.svg": "e67c",
	"./order_icon3.svg": "f0b9",
	"./order_icon3_cur.svg": "35b7",
	"./order_icon4.svg": "3bb1",
	"./order_icon4_cur.svg": "5d81",
	"./order_icon5.svg": "726f",
	"./order_icon5_cur.svg": "2725",
	"./order_icon6.svg": "a5ff",
	"./order_icon6_cur.svg": "e4a6",
	"./password.svg": "198d",
	"./phone.svg": "b470",
	"./points.svg": "4b72",
	"./points_cur.svg": "c12e",
	"./question.svg": "5d9e",
	"./record.svg": "c9d9",
	"./search.svg": "679a",
	"./share.svg": "2296",
	"./shop_cart.svg": "ab92",
	"./time_limit.svg": "7607",
	"./user_action1.svg": "cdcb",
	"./user_action2.svg": "eb92",
	"./user_action3.svg": "3cd5",
	"./user_action3_cur.svg": "4ccb",
	"./user_action4.svg": "4a88",
	"./user_action5.svg": "d53d",
	"./user_action6.svg": "bed7",
	"./user_action7.svg": "c010",
	"./user_action7_cur.svg": "e585"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "23f1";